import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from '../core/guards/auth.guard';
import { AdminGuard } from '../core/guards/admin.guard';
import { AdminShellComponent } from './admin-shell.component';
import { buildAdminChildRoutes } from './admin-route.config';

/**
 * Admin routes — definitions live in admin-route.config.ts (single source of truth
 * for paths, breadcrumb, title, tab strip, and components).
 */
const routes: Routes = [
  {
    path: 'admin',
    component: AdminShellComponent,
    canActivate: [AuthGuard, AdminGuard],
    data: { breadcrumb: 'Admin', accessLevel: 3 },
    children: buildAdminChildRoutes(),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
